import { useState } from "react"
import { router } from "@inertiajs/react"
import { StepShell } from "../components/StepShell"
import { DynamicList, KpiFieldRow } from "../components/DynamicList"
import { GuideMeCta } from "@/components/planning/client-only/GuideMeCta"
import { parseNamedTargetBullets } from "@/lib/guide-output"

function defaultRows(saved) {
  if (saved && saved.length > 0) return saved
  return Array.from({ length: 3 }, () => ({ name: "", target: "" }))
}

export function Kois({ data }) {
  const [rows, setRows] = useState(() => defaultRows(data.annualPlan.annualKois))
  const [processing, setProcessing] = useState(false)

  const submit = () => {
    setProcessing(true)
    router.patch(
      "/app/plan/intake",
      { step: "kois", annual_kois: rows, advance: "1" },
      { preserveScroll: true, onFinish: () => setProcessing(false) },
    )
  }

  // KOI bullets follow the same "Name: Target" shape as KPIs (see
  // IntakeGuideService). Parse + drop into the KOI table.
  const insertGuidedKois = (bullets) => {
    const parsed = parseNamedTargetBullets(bullets).slice(0, 5)
    if (parsed.length === 0) return
    while (parsed.length < 3) parsed.push({ name: "", target: "" })
    setRows(parsed)
  }

  return (
    <StepShell
      title="Annual Spiritual Dashboard"
      subtitle="3–5 Key Obedience Indicators. Practices that show you're walking with God and growing in surrender."
      onNext={submit}
      processing={processing}
    >
      <GuideMeCta
        section="kois"
        onInsert={insertGuidedKois}
        title="Not sure which KOIs to pick?"
        subtitle="Talk it through with an AI coach — it knows your goals and wheel scores, and will help you land on 3–5 practices that actually form you."
      />
      <DynamicList
        items={rows}
        onChange={setRows}
        min={3}
        max={5}
        newItem={() => ({ name: "", target: "" })}
        addLabel="Add another KOI"
        render={(item, update) => (
          <KpiFieldRow
            item={item}
            update={update}
            namePlaceholder="KOI name (e.g., Weekly Sabbath)"
            targetPlaceholder="Target (e.g., Every week)"
          />
        )}
      />
    </StepShell>
  )
}
